import { type Pagination, type PaginationFilter } from "../../../core/pagination/models";
import { type FilterBy, type GetLensesType } from "../../../gql-generated/types";
import { type GetLensesListQueryVariables } from "../queries";

export const toPaginationRequest = (
    pagination: Pagination,
    paginationFilter: PaginationFilter,
    type: GetLensesType,
    lensSpaceId?: string,
): GetLensesListQueryVariables => {
    const { limit, offset, sortBy, sortDirection } = pagination;
    const { locked, searchName, statuses, surfaceTypeList } = paginationFilter;
    const filterBy: Writeable<FilterBy> = {
        statusList: [],
        lockedList: [],
        nameList: [],
        unlockableIdList: [],
        surfaceTypeList: [],
    };

    if (locked !== undefined) {
        filterBy.lockedList = [locked];
    }

    if (searchName) {
        filterBy.nameList = [searchName];
    }

    if (statuses.length > 0) {
        filterBy.statusList = statuses;
    }

    filterBy.surfaceTypeList = surfaceTypeList;

    return {
        limit,
        offset,
        sortBy,
        sortDirection,
        filterBy,
        lensSpaceId: lensSpaceId ?? "",
        type,
    };
};
